/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'workorderFinished': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-40 644l-80-78.4-160-156.8 80-78.4 160 156.8L712 316l80 78.4L472 708z"/>'
  }
})
